(() => {
 'use strict';
 const setup = () => {
  const root = document.querySelector('[data-asos-48h]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const deadline = Date.parse(root.dataset.end);
  const label = root.querySelector('[data-asos-48h-heading]');
  const clock = root.querySelector('[data-asos-48h-time]');
  const update = () => {
   const remaining = deadline - Date.now();
   if (remaining <= 0) { root.hidden = true; document.documentElement.classList.remove('asos-48h-active'); return false; }
   root.hidden = false;
   document.documentElement.classList.add('asos-48h-active');
   const hours = Math.floor(remaining / 3600000);
   const minutes = Math.floor((remaining % 3600000) / 60000);
   const seconds = Math.floor((remaining % 60000) / 1000);
   clock.textContent = [hours,minutes,seconds].map(n => String(n).padStart(2,'0')).join(':');
   label.textContent = remaining <= 48*3600000 ? 'ÚLTIMAS HORAS' : '48 HORAS DE OFERTA';
   return true;
  };
  if (update()) {
   const timer = setInterval(() => { if (!update()) clearInterval(timer); },1000);
   document.addEventListener('visibilitychange', update);
  }
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();